'use strict';module.exports=require("./domains")(require("./domains/domains.json"));